// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './service/BaseVuex'
Vue.use(store)

Vue.config.productionTip = false
Vue.component('my-component', {
  template: '#template-hello'
})
Vue.component('my-header', {
  template: '<label>header</label><my-component></my-component>'
})
// Vue.tem
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store, // vuex
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js